define('collections/Podio.Collections.Questions',['require','lib/backbone/Backbone.PodioCollection','models/Podio.Models.Question'],function(require) {

  var PodioCollection = require('lib/backbone/Backbone.PodioCollection');

  return PodioCollection.extend({

    configure: function() {
      this.model = require('models/Podio.Models.Question');
    }

  });

});






